import * as React from 'react';
import { useEffect } from 'react';

import redirect from 'js/lib/coursera.redirect';
import { useParams } from 'js/lib/useRouter';
import user from 'js/lib/user';

import { Box, color } from '@coursera/coursera-ui';
import { SvgLoaderSignal } from '@coursera/coursera-ui/svg';

import 'css!./__styl__/DegreeRedirect';

const DegreeRedirect = () => {
  const { degreeSlug } = useParams();

  useEffect(() => {
    const authParams = !user.isAuthenticatedUser() ? `?authMode=login&redirectTo=${window.location.href}` : '';
    redirect.setLocation(`/degrees/${degreeSlug}${authParams}`);
  }, [degreeSlug]);

  return (
    <Box rootClassName="rc-DegreeRedirect" justifyContent="center" alignItems="center">
      <SvgLoaderSignal size={64} color={color.primary} />
    </Box>
  );
};

export default DegreeRedirect;
